import { render } from "./SdgsGoalRatio.vue?vue&type=template&id=c0872dac&scoped=true"
import script from "./SdgsGoalRatio.vue?vue&type=script&lang=js"
export * from "./SdgsGoalRatio.vue?vue&type=script&lang=js"

import "./SdgsGoalRatio.vue?vue&type=style&index=0&id=c0872dac&scoped=true&lang=css"

import exportComponent from "C:\\Qedtek Project\\Takayama-New\\takayama_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0872dac"]])

export default __exports__